import { Container, Grid } from '@material-ui/core'
import React, { useContext, useEffect } from 'react'
import FlexView from 'react-flexview/lib'
import { FormContext, useForm } from 'react-hook-form'
import policyModificationApi from '../../../../api/policyModification.api'
import { PolicyModificationContextStore } from '../../../../context/PolicyModificationContext'
import { EventEmitterService, EventKey } from '../../../../services/EventEmitterService'
import { awaitWithLoading } from '../../../../services/utils'
import { ContinueButton } from '../../../Core/Buttons/ContinueButton'
import { MotorcyclesDetailsSection } from './MotorcycleDetailsSection'

export const MotorcyclesDetailsForm = ({ defaultValues, isLojackFactordDisabled, onSave, index, needDisabled = false }) => {
  const form = useForm({ mode: 'onChange', defaultValues: { ...defaultValues } })
  const modifyContext = useContext(PolicyModificationContextStore)

  const saveMotorcycleForm = async data => {
    const motor = modifyContext.motorcycles_details.find(m => m.id == defaultValues.id)
    const updateData = { ...motor, ...data }
    if (updateData.is_motorcycle_include_odometer == undefined) {
      updateData.is_motorcycle_include_odometer = true
    }
    const validationResponse = await awaitWithLoading(
      policyModificationApi.validatePolicyMotorcycleData(updateData, modifyContext.insuranceId)
    )
    if (validationResponse.ok) {
      onSave(updateData, index)
    } else {
      EventEmitterService.dispatch(EventKey.ShowError, validationResponse)
    }
  }

  return (
    <React.Fragment>
      <FormContext {...form}>
        <form autoComplete="off" onSubmit={form.handleSubmit(saveMotorcycleForm)}>
          <Container>
            <MotorcyclesDetailsSection needDisabled={needDisabled} isLojackFactordDisabled={isLojackFactordDisabled} pushOther={false} />
            <Grid xs={4}>
              <FlexView vAlignContent="center" hAlignContent="left" className="margin-top-large">
                <ContinueButton label="Save" type="submit" />
              </FlexView>
            </Grid>
          </Container>
        </form>
      </FormContext>
    </React.Fragment>
  )
}
